import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";

const FullCalendarReact = ({ events, setCurrentMonth, renderEventContent }) => {
  const handleDatesSet = (dateInfo) => {
    const calendarApi = dateInfo.view.calendar;
    const currentStart = calendarApi.view.currentStart;

    const startOfMonth = moment(currentStart)
      .tz("Asia/Kolkata")
      .startOf("month");
    const endOfMonth = moment(currentStart).tz("Asia/Kolkata").endOf("month");

    setCurrentMonth((prevs) => ({
      ...prevs,
      selStartDate: startOfMonth.format("YYYY-MM-DD"),
      selEndDate: endOfMonth.format("YYYY-MM-DD"),
    }));
  };

  return (
    <FullCalendar
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      events={events}
      datesSet={handleDatesSet}
      eventContent={renderEventContent}
    />
  );
};

export default FullCalendarReact;

// date={new Date(date)}
// onNavigate={onNavigate}
